import StaffActionTypes from "./staff.types";

/** ***************** GET STAFF LIST START *********************** */
export const getStaffListStart = (getData: any) => ({
  type: StaffActionTypes.GET_STAFF_LIST_START,
  payload: getData,
});

export const getStaffListSuccess = (successData: any) => ({
  type: StaffActionTypes.GET_STAFF_LIST_SUCCESS,
  payload: successData,
});

export const getStaffListFailure = (failureData: any) => ({
  type: StaffActionTypes.GET_STAFF_LIST_FAILURE,
  payload: failureData,
});

export const getStaffListResponseResetStart = () => ({
  type: StaffActionTypes.GET_STAFF_LIST_RESPONSE_RESET,
});

export const getStaffListResponseChanged = () => ({
  type: StaffActionTypes.GET_STAFF_LIST_RESPONSE_CHANGED,
});

/** ***************** GET STAFF LIST END *********************** */

/** ***************** ADD STAFF DETAILS START *********************** */
export const addStaffDetailsStart = (addData: any) => ({
  type: StaffActionTypes.ADD_STAFF_DETAILS_START,
  payload: addData,
});

export const addStaffDetailsSuccess = (successData: any) => ({
  type: StaffActionTypes.ADD_STAFF_DETAILS_SUCCESS,
  payload: successData,
});

export const addStaffDetailsFailure = (failureData: any) => ({
  type: StaffActionTypes.ADD_STAFF_DETAILS_FAILURE,
  payload: failureData,
});

export const addStaffDetailsResponseResetStart = () => ({
  type: StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_RESET,
});

export const addStaffDetailsResponseChanged = () => ({
  type: StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD STAFF DETAILS END *********************** */

/** ***************** UPDATE STAFF DETAILS START *********************** */
export const updateStaffDetailsStart = (updateData: any) => ({
  type: StaffActionTypes.UPDATE_STAFF_DETAILS_START,
  payload: updateData,
});

export const updateStaffDetailsSuccess = (successData: any) => ({
  type: StaffActionTypes.UPDATE_STAFF_DETAILS_SUCCESS,
  payload: successData,
});

export const updateStaffDetailsFailure = (failureData: any) => ({
  type: StaffActionTypes.UPDATE_STAFF_DETAILS_FAILURE,
  payload: failureData,
});

export const updateStaffDetailsResponseResetStart = () => ({
  type: StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_RESET,
});

export const updateStaffDetailsResponseChanged = () => ({
  type: StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE STAFF DETAILS END *********************** */

/** ***************** DELETE STAFF DETAILS START *********************** */
export const deleteStaffDetailsStart = (deleteData: any) => ({
  type: StaffActionTypes.DELETE_STAFF_DETAILS_START,
  payload: deleteData,
});

export const deleteStaffDetailsSuccess = (successData: any) => ({
  type: StaffActionTypes.DELETE_STAFF_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteStaffDetailsFailure = (failureData: any) => ({
  type: StaffActionTypes.DELETE_STAFF_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteStaffDetailsResponseResetStart = () => ({
  type: StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_RESET,
});

export const deleteStaffDetailsResponseChanged = () => ({
  type: StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE STAFF DETAILS END *********************** */

/** ***************** FETCH STAFF DETAILS START *********************** */
export const fetchStaffDetailsStart = (fetchData: any) => ({
  type: StaffActionTypes.FETCH_STAFF_DETAILS_START,
  payload: fetchData,
});

export const fetchStaffDetailsSuccess = (successData: any) => ({
  type: StaffActionTypes.FETCH_STAFF_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchStaffDetailsFailure = (failureData: any) => ({
  type: StaffActionTypes.FETCH_STAFF_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchStaffDetailsResponseResetStart = () => ({
  type: StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_RESET,
});

export const fetchStaffDetailsResponseChanged = () => ({
  type: StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH STAFF DETAILS END *********************** */

/** ***************** GET BRANCH LIST START *********************** */
export const getBranchDropdownListStart = (getData: any) => ({
  type: StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_START,
  payload: getData,
});

export const getBranchListDropdownSuccess = (successData: any) => ({
  type: StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_SUCCESS,
  payload: successData,
});

export const getBranchListDropdownFailure = (failureData: any) => ({
  type: StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_FAILURE,
  payload: failureData,
});

export const getBranchListDropdownResponseResetStart = () => ({
  type: StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_RESET,
});

export const getBranchListDropdownResponseChanged = () => ({
  type: StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_CHANGED,
});

/** ***************** GET BRANCH LIST END *********************** */

/** ***************** GET USER TYPE LIST START *********************** */
export const getUserTypeDropdownListStart = (getData: any) => ({
  type: StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_START,
  payload: getData,
});

export const getUserTypeDropdownListSuccess = (successData: any) => ({
  type: StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_SUCCESS,
  payload: successData,
});

export const getUserTypeDropdownListFailure = (failureData: any) => ({
  type: StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_FAILURE,
  payload: failureData,
});

export const getUserTypeDropdownListResponseResetStart = () => ({
  type: StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_RESPONSE_RESET,
});

export const getUserTypeDropdownListResponseChanged = () => ({
  type: StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_RESPONSE_CHANGED,
});

/** ***************** GET USER TYPE LIST END *********************** */

/** ***************** GET DEPARTMENT LIST START *********************** */
export const getDepartmentDropdownListStart = (getData: any) => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_START,
  payload: getData,
});

export const getDepartmentDropdownListSuccess = (successData: any) => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_SUCCESS,
  payload: successData,
});

export const getDepartmentDropdownListFailure = (failureData: any) => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_FAILURE,
  payload: failureData,
});

export const getDepartmentDropdownListResponseResetStart = () => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_RESET,
});

export const getDepartmentDropdownListResponseChanged = () => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DEPARTMENT LIST END *********************** */

/** ***************** GET MANAGER LIST START *********************** */
export const getManagerDropdownListStart = (getData: any) => ({
  type: StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_START,
  payload: getData,
});

export const getManagerDropdownListSuccess = (successData: any) => ({
  type: StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_SUCCESS,
  payload: successData,
});

export const getManagerDropdownListFailure = (failureData: any) => ({
  type: StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_FAILURE,
  payload: failureData,
});

export const getManagerDropdownListResponseResetStart = () => ({
  type: StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_RESPONSE_RESET,
});

export const getManagerDropdownListResponseChanged = () => ({
  type: StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET MANAGER LIST END *********************** */

/** ***************** GET DEPARTMENT LIST START *********************** */
export const getdepartmentDropdownListStart = (getData: any) => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_START,
  payload: getData,
});

export const getdepartmentDropdownListSuccess = (successData: any) => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_SUCCESS,
  payload: successData,
});

export const getdepartmentDropdownListFailure = (failureData: any) => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_FAILURE,
  payload: failureData,
});

export const getdepartmentDropdownListResponseResetStart = () => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_RESET,
});

export const getdepartmentDropdownListResponseChanged = () => ({
  type: StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DEPARTMENT LIST END *********************** */
